import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { PayoutDetails } from "./PayoutDetails";

export function createClientPayoutDetailsRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/payouts/$payoutId",
    component: PayoutDetails,
    staticData: { reducedMobileTopPadding: true },
    head: () => ({
      meta: [{ title: "Payout Details" }],
    }),
  });
}
